












































import { defineComponent, computed } from '@vue/composition-api';
import DatePicker from '@/components/atoms/DatePicker.vue';
import Editor from '@/components/organisms/Editor.vue';

import { editingCardModule } from '@/store/modules/EditingCardStore';

export default defineComponent({
  components: { DatePicker, Editor },

  props: {
    language: {
      type: String,
      required: false,
      default: 'ja',
    },
  },

  setup(_, { emit }) {
    const editedItem = computed({
      get: () => editingCardModule.editedItem,
      set: (item: typeof editingCardModule.editedItem) =>
        editingCardModule.updateItem(item),
    });

    return {
      editedItem,
      fields: editingCardModule.fieldsExtendedRules,
    };
  },
});
